:host {
  .item-events {
    margin: 16px;
    padding: 16px;
    border: 1px solid var(--divider);
    border-radius: 8px;
    cursor: pointer;
    &:first-of-type {
      margin-top: 0;
    }

    &__info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 8px;
      .label {
        font-size: 14px;
        font-weight: 500;
        color: var(--font-primary);
      }
    }

    &__content {
      width: 90%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 14px;
      font-weight: 400;
      color: var(--font-secondary);
      margin-bottom: 16px;
    }

    &__link-date {
      display: flex;
      align-items: center;
      justify-content: space-between;
      a {
        color: var(--blue-link);
        text-decoration: none;
        font-size: 14px;
        font-weight: 400;
      }
      .date {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 12px;
        font-weight: 400;
        color: var(--font-secondary);
        .bullet {
          width: 4px;
          height: 4px;
          background: #d9d9d9;
          border-radius: 100px;
        }
      }
    }
  }
}
